import { Playground } from '../../../components/playground/Playground';
import { Description } from '../../../components/Description';
import { NavLink } from 'react-router-dom';

export const Pagination = () => (
    <div>
        <Description headline='Pagination' anchor='pagination' />

        <Playground example={paginationExample} />
    </div>
);

const paginationExample = (
    <div>
        <div className='display-flex gap-50 flex-wrap'>
            <ul className='pagination'>
                <li className='disabled'>
                    <span className='rioglyph rioglyph-chevron-left' />
                </li>
                <li>
                    <span>1</span>
                </li>
                <li className='active'>
                    <span>2</span>
                </li>
                <li>
                    <span>3</span>
                </li>
                <li>
                    <span>4</span>
                </li>
                <li>
                    <span>5</span>
                </li>
                <li>
                    <span className='rioglyph rioglyph-chevron-right' />
                </li>
            </ul>

            <ul className='pagination'>
                <li className='disabled'>
                    <span className='rioglyph rioglyph-chevron-left' />
                </li>
                <li />
                <li />
                <li className='active' />
                <li />
                <li />
                <li>
                    <span className='rioglyph rioglyph-chevron-right' />
                </li>
            </ul>
        </div>
        <h4 className='margin-top-25 padding-top-10'>Usage</h4>
        <p>
            Use pagination buttons only for UI elements that benefit from stepping through discrete content pages, such
            as: Image carousels – where users navigate through multiple slides or multi-step flows – to guide users
            through a process one step at a time.
        </p>
        <h5 className='display-flex gap-5 align-items-center'>
            <span className='rioglyph rioglyph-remove rioglyph-filled text-color-danger text-size-14' />
            <span>Not for Tables</span>
        </h5>
        <p>
            Tables should use a “<NavLink to='/components/loadMore'>Load more</NavLink>” button instead of pagination.
        </p>
        <h6>Why "Load more" is preferred</h6>
        <ul className='space-y-10'>
            <li>
                <b>Continuous scanning:</b>
                <br />
                Users can scroll down and view more data without breaking flow.
            </li>
            <li>
                <b>Less disruption:</b>
                <br />
                Avoids jarring page reloads or resets when switching pages.
            </li>
            <li>
                <b>Improved comparability:</b>
                <br />
                All previously loaded data stays in view, enabling easier side-by-side comparison of rows.
            </li>
            <li>
                <b>Less cognitive load:</b>
                <br />
                Users rarely remember what was on “Page 6”, especially when rows are changing. Sequential pages
                interrupt scanning and exploration.
            </li>
            <li>
                <b>No page size UI:</b>
                <br />
                You don’t need to offer dropdowns for rows per page, reducing UI clutter.
            </li>
        </ul>
    </div>
);
